import defaultTemplate from './defaultTemplate.json';
import * as backofficeApi from '../api/backofficeApi';
import versionDefaultFile from './../../styles/default/version.json';
import { VersionTemplate } from './VersionTemplate';
import { getLogger } from '../logger';

const debug = getLogger('service:templates:templateService');

const FONTS_CSS_FILE = 'fonts.css';

//----------------------------------------------------------------------------------------------------------------------
function mergeColors(colors) {
  let colorsMerged = {};

  colorsMerged = colors;

  if (!colors) colorsMerged = defaultTemplate.colors;

  if (!colors.primary) colorsMerged.primary = defaultTemplate.colors.primary;
  if (!colors.backgroundPrimary) colorsMerged.backgroundPrimary = defaultTemplate.colors.backgroundPrimary;
  if (!colors.backgroundSecondary) colorsMerged.backgroundSecondary = defaultTemplate.colors.backgroundSecondary;

  if (!colors.btnDefault) colorsMerged.btnDefault = defaultTemplate.colors.btnDefault;
  if (!colors.btnDefaultHover) colorsMerged.btnDefaultHover = defaultTemplate.colors.btnDefaultHover;
  if (!colors.btnSuccess) colorsMerged.btnSuccess = defaultTemplate.colors.btnSuccess;
  if (!colors.btnSuccessHover) colorsMerged.btnSuccessHover = defaultTemplate.colors.btnSuccessHover;
  if (!colors.btnDanger) colorsMerged.btnDanger = defaultTemplate.colors.btnDanger;
  if (!colors.btnDangerHover) colorsMerged.btnDangerHover = defaultTemplate.colors.btnDangerHover;

  return colorsMerged;
}

//----------------------------------------------------------------------------------------------------------------------
function getImagesIcons(url) {
  let icons = {};

  icons.alertSuccess = url + defaultTemplate.images.icons.alertSuccess;
  icons.alertError = url + defaultTemplate.images.icons.alertError;
  icons.alertWarning = url + defaultTemplate.images.icons.alertWarning;
  icons.groupColor = url + defaultTemplate.images.icons.groupColor;
  icons.groupBg = url + defaultTemplate.images.icons.groupBg;
  icons.individualColor = url + defaultTemplate.images.icons.individualColor;
  icons.individualBg = url + defaultTemplate.images.icons.individualBg;

  return icons;
}

//----------------------------------------------------------------------------------------------------------------------
function getImagesAvatars(url) {
  let avatars = {};
  let defaultAvatars = defaultTemplate.images.avatars;

  // TODO:II
  // ESTO SIGUE HACIENDO FALTA?

  Object.keys(defaultAvatars).map(function(key, index) {
    return (avatars[key] = url + defaultAvatars[key]);
  });

  return avatars;
}

//----------------------------------------------------------------------------------------------------------------------
function getImagesClassrooms(url) {
  let classrooms = {};

  let defaultClassrooms = defaultTemplate.images.classrooms;

  Object.keys(defaultClassrooms).map(function(key, index) {
    return (classrooms[key] = url + defaultClassrooms[key]);
  });

  return classrooms;
}

function getLessonImagesPlaceholders(url) {
  let lessonPlaceholders = {};

  lessonPlaceholders.default = url + defaultTemplate.images.placeholders.lesson.default;
  lessonPlaceholders['text/csv'] = url + defaultTemplate.images.placeholders.lesson['text/csv'];
  lessonPlaceholders['application/msword'] = url + defaultTemplate.images.placeholders.lesson['application/msword'];
  lessonPlaceholders['image/gif'] = url + defaultTemplate.images.placeholders.lesson['image/gif'];
  lessonPlaceholders['image/jpeg'] = url + defaultTemplate.images.placeholders.lesson['image/jpeg'];
  lessonPlaceholders['web/resource'] = url + defaultTemplate.images.placeholders.lesson['web/resource'];
  lessonPlaceholders['application/vnd.oasis.opendocument.presentation'] =
    url + defaultTemplate.images.placeholders.lesson['application/vnd.oasis.opendocument.presentation'];
  lessonPlaceholders['application/vnd.oasis.opendocument.spreadsheet'] =
    url + defaultTemplate.images.placeholders.lesson['application/vnd.oasis.opendocument.spreadsheet'];
  lessonPlaceholders['application/vnd.oasis.opendocument.text'] =
    url + defaultTemplate.images.placeholders.lesson['application/vnd.oasis.opendocument.text'];
  lessonPlaceholders['application/pdf'] = url + defaultTemplate.images.placeholders.lesson['application/pdf'];
  lessonPlaceholders['image/png'] = url + defaultTemplate.images.placeholders.lesson['image/png'];
  lessonPlaceholders['application/vnd.ms-powerpoint'] =
    url + defaultTemplate.images.placeholders.lesson['application/vnd.ms-powerpoint'];
  lessonPlaceholders['application/vnd.openxmlformats-officedocument.presentationml.presentation'] =
    url +
    defaultTemplate.images.placeholders.lesson[
      'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    ];
  lessonPlaceholders['application/vnd.ms-excel'] =
    url + defaultTemplate.images.placeholders.lesson['application/vnd.ms-excel'];

  return lessonPlaceholders;
}

function getTaskImagesPlaceholders(url) {
  let taskPlaceholders = {};

  taskPlaceholders['taskImageGroup'] = url + defaultTemplate.images.placeholders.task['taskImageGroup'];
  taskPlaceholders['taskImageIndividual'] = url + defaultTemplate.images.placeholders.task['taskImageIndividual'];

  return taskPlaceholders;
}

//----------------------------------------------------------------------------------------------------------------------
function getImagesPlaceholders(url) {
  let placeholders = {};

  placeholders.emptyClassrooms = url + defaultTemplate.images.placeholders.emptyClassrooms;
  placeholders.book = url + defaultTemplate.images.placeholders.book;
  placeholders.empty = url + defaultTemplate.images.placeholders.empty;
  placeholders.csvIcon = url + defaultTemplate.images.placeholders.csvIcon;
  placeholders.attachmentIcon = url + defaultTemplate.images.placeholders.attachmentIcon;
  placeholders.authoringNotification = url + defaultTemplate.images.placeholders.authoringNotification;
  placeholders.lesson = getLessonImagesPlaceholders(url);
  placeholders.task = getTaskImagesPlaceholders(url);

  return placeholders;
}

//----------------------------------------------------------------------------------------------------------------------
function getImagesLogos(url) {
  let logos = {};
  logos.favicon = url + defaultTemplate.images.logos.favicon;
  logos.bigDark = url + defaultTemplate.images.logos.bigDark;
  logos.bigLight = url + defaultTemplate.images.logos.bigLight;
  logos.small = url + defaultTemplate.images.logos.small;

  return logos;
}

//----------------------------------------------------------------------------------------------------------------------
function getImagesHeaders(url) {
  let headers = {};
  headers.book = url + defaultTemplate.images.headers.book;
  headers.menu = url + defaultTemplate.images.headers.menu;

  return headers;
}

//----------------------------------------------------------------------------------------------------------------------
function getImagesImages(url) {
  return {
    emojiAcceptableActive: url + defaultTemplate.images.emojis.emojiAcceptableActive,
    emojiAcceptableInactive: url + defaultTemplate.images.emojis.emojiAcceptableInactive,
    emojiExcellentActive: url + defaultTemplate.images.emojis.emojiExcellentActive,
    emojiExcellentInactive: url + defaultTemplate.images.emojis.emojiExcellentInactive,
    emojiGoodActive: url + defaultTemplate.images.emojis.emojiGoodActive,
    emojiGoodInactive: url + defaultTemplate.images.emojis.emojiGoodInactive,
    emojiPoorActive: url + defaultTemplate.images.emojis.emojiPoorActive,
    emojiPoorInactive: url + defaultTemplate.images.emojis.emojiPoorInactive,
    emojiVeryPoorActive: url + defaultTemplate.images.emojis.emojiVeryPoorActive,
    emojiVeryPoorInactive: url + defaultTemplate.images.emojis.emojiVeryPoorInactive,
    emojiPending: url + defaultTemplate.images.emojis.emojiPending
  };
}

//----------------------------------------------------------------------------------------------------------------------
function getImages(url) {
  let images = {};

  images.icons = getImagesIcons(url);
  images.avatars = getImagesAvatars(url);
  images.classrooms = getImagesClassrooms(url);
  images.placeholders = getImagesPlaceholders(url);
  images.logos = getImagesLogos(url);
  images.headers = getImagesHeaders(url);
  images.splashScreen = url + defaultTemplate.images.splashScreen;
  images.emojis = getImagesImages(url);

  return images;
}

/**
 * Verify the first two characters of version to determine if it is a compatible version
 *For example :
 * 0.1.0 <=> 0.1.1 => IS COMPATIBLE
 * 0.2.0 <=> 0.1.1 => IS NOT COMPATIBLE
 * **/
let isValidVersion = (versionSupportedString, customVersionString) => {
  if (!versionSupportedString || !customVersionString) return false;

  let versionSupported = new VersionTemplate(versionSupportedString);
  let customVersion = new VersionTemplate(customVersionString);

  return versionSupported.isCompatible(customVersion);
};

//----------------------------------------------------------------------------------------------------------------------
/**
 * Load template of url and merged with the default template
 * @param url Url of custom template
 * */
export let loadAndMergeTemplate = (url = '') => {
  if (!url || url === 'undefined') Promise.resolve(defaultTemplate);

  let templateMerged = {};

  return backofficeApi.getThemeVersion(url).then(versionData => {
    if (!isValidVersion(versionDefaultFile.version, versionData.version)) {
      return Promise.reject(
        `CUSTOM TEMPLATE NOT LOADED: Template supported (v${versionDefaultFile.version}) <> Custom template (v${versionData.version})`
      );
    }
    debug(
      'CUSTOM TEMPLATE LOADED: Template supported (v%s) ~ Custom template (v%s)',
      versionDefaultFile.version,
      versionData.version
    );

    return backofficeApi.getThemeColors(url).then(colors => {
      return backofficeApi.getThemeLayout(url).then(layout => {
        templateMerged.urlFonts = `${url}/${FONTS_CSS_FILE}`;
        templateMerged.colors = mergeColors(colors);
        templateMerged.layoutSettings = layout;
        templateMerged.images = getImages(`${url}/`);
        return templateMerged;
      });
    });
  });
};
